module.exports = __webpack_public_path__ + "img/quick-label-print-button-fr.57d34998.png";